import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/airline'

export const airlineService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    syncFirebase,
    getOptions
};

//syncFirebase
function syncFirebase(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'POST', { data: data });
}

//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}

//getOptions
function getOptions() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { showAlert:false })
}